import { createSelector } from 'reselect';
import { hasVideo } from './media-availability';
import { selectAccessibleCameras } from '../../devices/selectors';
import { browser } from '../../../common/services/browser';
export const selectFlipCameraAvailability = createSelector(hasVideo, selectAccessibleCameras, (isVideoEnabled, accessibleCameras) => isVideoEnabled && accessibleCameras.length > 1);
export const selectFlipCameraAvailabilityOnMobile = createSelector(selectFlipCameraAvailability, (isFlipCameraAvailable) => browser.isHandheld() && isFlipCameraAvailable);
